(ns storrito.fabricjs.canvas-data
  (:require [goog.object :as obj]))

;; Concept:
;;
;; Contains functions that helps to convert FabricJS JS objects into
;; Clojure data.

(def extra-property-names
  "Serialised property names.
  If some are not included they will not end up in the final fabricjs object."
  #js["id"
      "video_src"
      "external_id"
      "location"
      "poll"
      "countdown"
      "quiz"
      "layer-idx"
      "editable"
      "sticker-design"
      "lockScalingFlip"
      "max-scale"
      "slider"
      "question"
      "min-scale"
      "design"
      ;; Background Props
      "hasControls"
      "lockMovementX"
      "lockMovementY"
      "lockScalingX"
      "lockScalingY"
      "lockRotation"
      "link"
      "text"
      "selectable"
      "evented"
      "user-id"
      ])

(defn canvas-object->js-data
  "Converts a Fabricjs object to a pure JS object (transfers the
   extra property `id`). While converting this function only takes properties
   that are in extra-property-names"
  [^js/fabric.Object canvas-object]
  (let [object (.toObject canvas-object
                          extra-property-names)]
    ;; When this is a video, remove the `src` element so fabricjs
    ;; doesn't try to load the video as an image.
    (when (obj/get object "video_src")
      (obj/remove object "src"))

    object))

(defn canvas-object->clj
  "Converts a Fabricjs object to Clojure data."
  ([canvas-object]
   (-> canvas-object
     (canvas-object->js-data)
     (js->clj :keywordize-keys true))))
